import { useTranslations } from 'next-intl';

/**
 * Shared display label for winner-less match outcomes. `legacyWalkover` is
 * the pre-outcome-column `is_walkover` flag — consulted only when `outcome`
 * itself is absent (pre-column rows), matching `isWinnerlessRow`'s fallback.
 */
export function useOutcomeLabel() {
  const t = useTranslations('Matches');
  return (outcome: string | null | undefined, legacyWalkover: boolean) => {
    if (outcome === 'dual_withdrawal') return t('dualWithdrawal');
    if (outcome === 'not_played') return t('notPlayed');
    if (outcome === 'walkover' || (outcome == null && legacyWalkover)) return t('walkoverShort');
    return null;
  };
}
